import { ref } from "vue";

const isLoading = ref(true);
const loadingText = ref<string | null>(null);

export const useGlobalLoader = () => {
  const showGlobalLoader = (text?: string) => {
    loadingText.value = text ?? null;
    isLoading.value = true;
  };

  const hideGlobalLoader = () => {
    isLoading.value = false;
    loadingText.value = null;
  };

  const setLoadingText = (text: string | null) => {
    loadingText.value = text;
  };

  return {
    showGlobalLoader,
    hideGlobalLoader,
    setLoadingText,
    isLoading,
    loadingText,
  };
};
